<template>
  <d-card class="card-small user-details mb-4 mt-5">
    <!-- Card Header -->
    <d-card-header class="p-0">
      <div class="user-details__bg"></div>
    </d-card-header>

    <d-card-body class="p-0">
      <!-- User Avatar -->
      <div class="user-details__avatar mx-auto">
        <img :src="userData.avatarImg" :alt="userData.name" />
      </div>

      <!-- User Name -->
      <h4 class="text-center m-0 my-2">{{ userData.name }}</h4>

      <!-- User Data -->
      <div class="user-details__user-data border-top border-bottom p-4">
        <div class="row mb-3">
          <div class="col w-50">
            <span>Location</span>
            <span>{{ userData.location }}</span>
          </div>
          <div class="col w-50">
            <span>Access Level</span>
            <span class="ql-color-green">{{ userData.access }}</span>
          </div>
        </div>
        <div class="row"></div>
      </div>
    </d-card-body>
  </d-card>
</template>

<script>
const defaultUserData = {
  avatarImg: require("@/assets/images/avatars/avatar.svg"),
  name: "Sierra Brooks",
  email: "sierra@example.com",
  location: "Remote",
  access: "OWNER"
};

export default {
  name: "user-details",
  props: {
    /**
     * The user data
     */
    userData: {
      type: Object,
      default() {
        return defaultUserData;
      }
    }
  }
};
</script>
